// Every preference the page can render, with the value used until the merchant's own
// profile says otherwise. `merged` in the page layers the saved profile over this.
export const DEFAULTS = {
  auto_approve_all: false,
  max_auto_approve_amount: 250,
  // Auto-submission: evidence is always submitted automatically (no on/off toggle).
  // 'all'       -> every dispute is submitted regardless of amount.
  // 'threshold' -> disputes up to max_auto_approve_amount are submitted; larger ones
  //                are held for review but still auto-submitted on the last day before
  //                the deadline as a safety net so nothing lapses.
  auto_submit_mode: "all",
  // How many days to wait before auto-submitting (gives the team time to intervene).
  auto_submit_delay_days: 2,
  // Legacy submission-delay fields (the standalone section was merged into the
  // Auto-submission setup modal). Kept so nothing that still reads them breaks.
  submission_delay_mode: "immediate",
  delay_days_after_init: 2,
  // 'due_date' mode: send this many days before the issuer's response deadline.
  days_before_due: 2,
  // Per-reason-code rules. Dict of { reason_code: amount }.
  // Amount = 0 means "always queue for manual review", absorbing the old
  // `excluded_reason_codes` list. Amount > 0 is the auto-approve ceiling
  // for that reason code (overriding the global max).
  per_reason_code_max_amounts: {},
  // Repeat-disputer routing. Off by default: the toggle gates it, and the threshold is
  // only editable while it's on.
  repeat_disputer_enabled: false,
  repeat_disputer_threshold: 0,
  // Ignore low-value disputes: below this amount the dispute is not auto-submitted
  // and is marked Skipped (not worth the effort / submission fee). This `false` is the
  // no-Stripe default; a connected Stripe account flips the default to true (see the
  // `merged` memo), and either way the merchant's own toggle wins.
  ignore_low_value_enabled: false,
  ignore_below_amount: 15,
  // Team members (ids) that new disputes are auto-assigned to, round-robin. Empty
  // means assign manually.
  auto_assign_to: [],
  // Automatic-approval rules (CategoryRules). Each entry:
  // { id, action: 'auto' | 'manual', conditions: [{ field, op, value }] }.
  // Disputes matching no rule follow the global auto-submit rule.
  approval_rules: [],
  // Assignment rules (AssignmentRules). Each entry:
  // { id, assignee: <memberId>, conditions: [{ field, op, value }] }.
  // Disputes matching no rule use the default round-robin assignees (auto_assign_to).
  assignment_rules: []
}

// Shared empty fallback so a missing slice value keeps a stable identity.
export const EMPTY = []
